import { collectionServiceClient } from "@/api/index";
import {
  SaveUrgeCaseBaseInfo,
  SaveRemindCaseReq
} from "@/pbjs/xcommon/collection_pb.js";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData, timeFormat } from "@/utils";
// lee 绩效接口参数
interface Options {
  Result: string;
  Caseid: number; // 工单分类
  Orderid: string; // 用户id
  Phoneobject: number;
  Phonecallinput?: string;
  Phoneconnected: number;
  Repayinclination?: number;
  Phoneunconnectreason?: number;
  Reasonitem: number;
  Remark?: number;
  Communicationway: number;
  Callid: string;
  Itemid: number;
  Phonetime: string; // 角色
  Promiserepaytime?: string;
  nextDialTime?: string; // dialer下次拨打时间
  Promiserepayamount?:string;

}
export function saveRemindCaseApi(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let saveObj: any = new SaveUrgeCaseBaseInfo();
      saveObj.setResult(arg.Result);
      saveObj.setNextdialtime(arg.nextDialTime);
      saveObj.setRemark(arg.Remark); //
      saveObj.setCaseid(arg.Caseid); //
      saveObj.setTotalriskreport("");
      saveObj.setOrderid(arg.Orderid); //
      saveObj.setPhoneconnected(arg.Phoneconnected); //
      if (arg.Repayinclination) {
        saveObj.setRepayinclination(arg.Repayinclination);
      } //
      if (arg.Phoneunconnectreason) {
        saveObj.setPhoneunconnectreason(arg.Phoneunconnectreason);
      } //
      saveObj.setPhoneobject(arg.Phoneobject); //
      if (arg.Phonecallinput) {
        saveObj.setPhonecallinput(arg.Phonecallinput);
      }
      saveObj.setReasonitem(arg.Reasonitem); //
      saveObj.setCommunicationway(arg.Communicationway); //
      saveObj.setCommunicationwayremark("");
      if (arg.Promiserepaytime) {
        saveObj.setPromiserepaytime(timeFormat(arg.Promiserepaytime));
      } //
      if (arg.Promiserepayamount) {
        saveObj.setPromiserepayamount(arg.Promiserepayamount)
      }
      saveObj.setPhonetime(timeFormat(arg.Phonetime));
      // saveObj.setPhonetime(this.resData);
      saveObj.setCallid(arg.Callid);
      saveObj.setItemid(arg.Itemid);
      let request: any = new SaveRemindCaseReq();
      request.setCommonin(setCommon());
      request.setBaseinfo(saveObj);
      let _res = await collectionServiceClient.saveRemindCase(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      // response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// function getWorkerPerformance(arg: Options) {
//     let _res = getWorkerPerformanceApi(arg);
//     return _res;
// }
